import React from "react";
import { cn } from "@/lib/utils";

interface KeyValueCardProps {
    label: string;
    value: string;
    className?: string;
    id: string;
}

const KeyValueCard: React.FC<KeyValueCardProps> = ({ label, value, className, id }) => {
    return (
        <div className="gs-setting-row">
            <h6 className="gs-setting-row__label" id={`${id}-label`}>
                {label}
            </h6>
            <p className={cn("gs-setting-row__value", className)} id={`${id}-value`}>
                {value}
            </p>
        </div>
    );
};

export default KeyValueCard;
